import React from 'react'
import styled from 'styled-components'
import Navbar from '../../../components/Navbar'

const PDF_URL = 'https://startse-landings.s3.us-east-2.amazonaws.com/docs/pdf/alun_codigo_etica.pdf'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
`

const PdfContainer = styled.div`
  flex: 1;
  margin-top: 64px;

  object,
  embed {
    width: 100%;
    height: 100%;
    border: none;
  }
`

const Fallback = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-size: 18px;
  font-family: 'IBM Plex Sans', Barlow, sans-serif;

  a {
    color: #0080ED;
  }
`

export default function Ethics() {
  return (
    <Wrapper>
      <Navbar />

      <PdfContainer>
        <object data={PDF_URL} type="application/pdf">
          <embed src={PDF_URL} type="application/pdf" />
          <Fallback>
            <p>
              Seu navegador não suporta a exibição de PDFs.{' '}
              <a href={PDF_URL} target="_blank" rel="noopener noreferrer">
                Clique aqui para acessar o documento
              </a>
              .
            </p>
          </Fallback>
        </object>
      </PdfContainer>
    </Wrapper>
  )
}
